<template>
  <div class="page">
    <div class="back">
      <img src="@/assets/new/back.png" alt="" @click="goback" />
      <span @click="goback">聚合云资讯</span>
    </div>

    <div class="container" v-if="id == 1" :key="1">
      <div class="content">
        <div class="title">
          <span>探讨行业发展 | 支付要闻更新</span>
        </div>
        <div class="time">
          <span>2024-03-21</span>
        </div>
        <div class="article">
          <p>
            随着《非银行支付机构监督管理条例》（以下简称《条例》）的正式发布，注定2024年也将是支付行业至关重要的一年，不仅政策落地，同时行业也面临着各类转型机遇。
          </p>
          <br />
          <p>
            在此，聚合云集团提炼要点要闻，针对内容进行分享，希望能够给行业人带来启发。
          </p>
        </div>
        <div class="imgs">
          <img src="@/assets/new/art1_header.png" alt="" />
          <img src="@/assets/new/art1_footer.png" alt="" />
        </div>
      </div>
    </div>

    <div class="container" v-if="id == 2" :key="2">
      <div class="content">
        <div class="title">
          <span>支付监管规则更新强化《非银行支付机构监督管理条例》发布</span>
        </div>
        <div class="time">
          <span>2023-12-21</span>
        </div>
        <div class="article">
          <p>
            随着《非银行支付机构监督管理条例》（以下简称《条例》）的正式发布，注定2024年也将是支付行业至关重要的一年，不仅政策落地，同时行业也面临着各类转型机遇。
          </p>
          <br />
          <p>
            在此，聚合云集团提炼要点要闻，针对内容进行分享，希望能够给行业人带来启发。
          </p>
        </div>
        <div class="imgs">
          <img src="@/assets/new/art3_header.png" alt="" />
          <img src="@/assets/new/art3_footer.png" alt="" />
        </div>
      </div>
    </div>

    <div class="container" v-if="id == 3" :key="3">
      <div class="content">
        <div class="title">
          <span>中秋国庆支付数据发布：部分行业增长明显</span>
        </div>
        <div class="time">
          <span>2024-03-21</span>
        </div>
        <div class="article">
          <p>
            随着《非银行支付机构监督管理条例》（以下简称《条例》）的正式发布，注定2024年也将是支付行业至关重要的一年，不仅政策落地，同时行业也面临着各类转型机遇。
          </p>
          <br />
          <p>
            在此，聚合云集团提炼要点要闻，针对内容进行分享，希望能够给行业人带来启发。
          </p>
        </div>
        <div class="imgs">
          <img src="@/assets/new/art2.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsDetail",
  data() {
    return {
      id: 0,
      timer: null,
    };
  },
  created() {
    this.id = localStorage.getItem("id");
    this.backTop();
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    backTop() {
      let that = this;
      cancelAnimationFrame(that.timer);
      that.timer = requestAnimationFrame(function fn() {
        var oTop = document.body.scrollTop || document.documentElement.scrollTop;
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop = oTop - 50;
          that.timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(that.timer);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
h3 {
  font-weight: normal;
}

/* 全局页面 */
.page {
  width: 100%;
  min-height: 100vh;
  background-color: #f1f1f1;
  padding: 0 20px; /* 移动端左右留白 */
}

/* 返回栏 */
.back {
  max-width: 1232px;
  margin: 0 auto;
  padding: 20px 0;
  display: flex;
  align-items: center;
  img {
    width: 10px;
    margin-right: 10px;
    cursor: pointer;
  }
  span {
    cursor: pointer;
    font-size: 14px;
    color: #de1f26;
  }
}

/* 内容容器 */
.container {
  max-width: 1232px;
  width: 100%;
  background-color: #fff;
  margin: 0 auto 30px;
  padding: 30px 20px;
  border-radius: 8px;
}

/* 文章内容 */
.content {
  max-width: 1010px;
  width: 100%;
  margin: 0 auto;
  .title {
    font-size: 24px;
    color: #333;
    line-height: 1.4;
  }
  .time {
    font-size: 14px;
    color: #868e9c;
    margin-top: 15px;
    padding-bottom: 15px;
    border-bottom: 2px solid #e5e5e5;
  }
  .article {
    font-size: 16px;
    color: #333;
    margin-top: 20px;
    line-height: 1.7;
    p {
      text-indent: 2rem;
      margin-bottom: 10px;
    }
  }
  .imgs {
    padding: 30px 0;
    img {
      width: 100%;
      height: auto;
      display: block;
      margin-bottom: 15px;
    }
  }
}

/* PC 端大尺寸样式 */
@media (min-width: 768px) {
  .content {
    .title {
      font-size: 36px;
    }
    .time {
      margin-top: 30px;
      padding-bottom: 30px;
    }
    .article {
      margin-top: 30px;
    }
    .imgs {
      padding: 50px 0;
    }
  }
}
</style>
